/* Delivery estimate line under the "In Stock" alert.
 * Rendered by snippets/product-buy-box.liquid, which also emits the JSON config
 * (<script type="application/json" data-ship-est-config>) from theme settings.
 *
 * Shopify does not expose shipping profiles to the storefront, so the transit
 * windows live in Theme settings > Shipping and must be kept in sync by hand.
 * No network calls. The visitor's ZIP is remembered in localStorage.
 */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-ship-est-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var STORAGE_KEY = 'sbz_ship_zip';
  var TIME_ZONE = 'America/Los_Angeles';
  var MONTHS = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  var cutoffHour = isFinite(cfg.cutoffHour) ? Number(cfg.cutoffHour) : 12;
  /* Extra business days added to every window (theme setting). */
  var bufferDays = isFinite(cfg.bufferDays) ? Math.max(0, parseInt(cfg.bufferDays, 10) || 0) : 1;
  var unavailableText = cfg.unavailableText || 'Need an ETA?';
  var phone = String(cfg.phone || '').trim();
  var phoneHref = phone ? 'tel:' + (phone.replace(/\D/g, '').length === 10 ? '+1' : '') + phone.replace(/[^\d+]/g, '') : '';
  /* Variants at/above this weight go by pallet or freight; no date estimate is possible. */
  var heavyGrams = (isFinite(cfg.heavyLb) && Number(cfg.heavyLb) > 0) ? Number(cfg.heavyLb) * 453.59237 : Infinity;
  var currentGrams = Number(cfg.initialGrams) || 0;

  /* ZIP ranges -> state. First match wins, so single-ZIP exceptions come
   * before the range that would otherwise swallow them. */
  var ZIP_RANGES = [
    [501, 501, 'NY'], [544, 544, 'NY'], [300, 999, 'PR'],
    [1000, 2799, 'MA'], [2800, 2999, 'RI'], [3000, 3899, 'NH'], [3900, 4999, 'ME'],
    [5501, 5501, 'MA'], [5544, 5544, 'MA'], [5000, 5999, 'VT'],
    [6390, 6390, 'NY'], [6000, 6999, 'CT'], [7000, 8999, 'NJ'],
    [10000, 14999, 'NY'], [15000, 19699, 'PA'], [19700, 19999, 'DE'],
    [20000, 20099, 'DC'], [20100, 20199, 'VA'], [20598, 20598, 'VA'], [20200, 20599, 'DC'],
    [20600, 21999, 'MD'], [22000, 24699, 'VA'], [24700, 26999, 'WV'],
    [27000, 28999, 'NC'], [29000, 29999, 'SC'], [30000, 31999, 'GA'], [32000, 34999, 'FL'],
    [35000, 36999, 'AL'], [37000, 38599, 'TN'], [39800, 39999, 'GA'], [38600, 39999, 'MS'],
    [40000, 42999, 'KY'], [43000, 45999, 'OH'], [46000, 47999, 'IN'], [48000, 49999, 'MI'],
    [50000, 52999, 'IA'], [53000, 54999, 'WI'], [55000, 56899, 'MN'], [56900, 56999, 'DC'],
    [57000, 57999, 'SD'], [58000, 58999, 'ND'], [59000, 59999, 'MT'],
    [60000, 62999, 'IL'], [63000, 65999, 'MO'], [66000, 67999, 'KS'], [68000, 69999, 'NE'],
    [70000, 71599, 'LA'], [71600, 72999, 'AR'],
    [73000, 73199, 'OK'], [73301, 73399, 'TX'], [73400, 74999, 'OK'], [75000, 79999, 'TX'],
    [80000, 81999, 'CO'], [82000, 83199, 'WY'], [83200, 83999, 'ID'], [84000, 84999, 'UT'],
    [85000, 86999, 'AZ'], [87000, 88499, 'NM'], [88500, 88599, 'TX'], [88900, 89999, 'NV'],
    [90000, 96699, 'CA'], [96700, 96999, 'HI'], [97000, 97999, 'OR'],
    [98000, 99499, 'WA'], [99500, 99999, 'AK']
  ];

  function stateFor(zip) {
    var n = parseInt(zip, 10);
    if (!isFinite(n)) return null;
    for (var i = 0; i < ZIP_RANGES.length; i++) {
      if (n >= ZIP_RANGES[i][0] && n <= ZIP_RANGES[i][1]) return ZIP_RANGES[i][2];
    }
    return null;
  }

  /* "1-2: CA, NV, AZ" per line -> { CA: [1, 2], ... } */
  var zones = {};
  String(cfg.zones || '').split(/\r?\n/).forEach(function (line) {
    var m = line.match(/^\s*(\d+)\s*-\s*(\d+)\s*:\s*(.+)$/);
    if (!m) return;
    var min = parseInt(m[1], 10), max = parseInt(m[2], 10);
    m[3].toUpperCase().split(/[\s,]+/).forEach(function (st) {
      if (st) zones[st] = [Math.min(min, max), Math.max(min, max)];
    });
  });

  var holidays = {};
  String(cfg.holidays || '').split(/\r?\n/).forEach(function (line) {
    var d = line.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) holidays[d] = true;
  });

  /* ---- date math (UTC-midnight Date objects standing in for calendar days) ---- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dayKey(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function isBusinessDay(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !holidays[dayKey(d)]; }
  function addDays(d, n) { var r = new Date(d.getTime()); r.setUTCDate(r.getUTCDate() + n); return r; }
  function addBusinessDays(d, n) {
    var r = d;
    while (n > 0) { r = addDays(r, 1); if (isBusinessDay(r)) n--; }
    return r;
  }

  function nowInPacific() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TIME_ZONE, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var hour = parseInt(o.hour, 10);
      if (hour === 24) hour = 0;
      return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), hour: hour };
    } catch (e) {
      var n = new Date();
      return { date: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), hour: n.getHours() };
    }
  }

  function shipDate() {
    var now = nowInPacific();
    var d = now.date;
    if (isBusinessDay(d) && now.hour < cutoffHour) return d;
    do { d = addDays(d, 1); } while (!isBusinessDay(d));
    return d;
  }

  function formatRange(a, b) {
    var ma = MONTHS[a.getUTCMonth()], mb = MONTHS[b.getUTCMonth()];
    var da = a.getUTCDate(), db = b.getUTCDate();
    if (a.getTime() === b.getTime()) return ma + ' ' + da;
    if (ma === mb) return ma + ' ' + da + '\u2013' + db;
    return ma + ' ' + da + '\u2013' + mb + ' ' + db;
  }

  /* ---- ZIP source ---- */
  function cleanZip(v) {
    var m = String(v || '').match(/^\s*(\d{5})/);
    return m ? m[1] : '';
  }
  function storedZip() {
    try { return cleanZip(window.localStorage.getItem(STORAGE_KEY)); } catch (e) { return ''; }
  }
  function saveZip(zip) {
    try { window.localStorage.setItem(STORAGE_KEY, zip); } catch (e) { /* private mode etc. */ }
  }
  function currentZip() {
    return storedZip() || cleanZip(cfg.customerZip) || cleanZip(cfg.originZip);
  }

  /* ---- rendering ---- */
  function stop(e) { e.stopPropagation(); }

  function render() {
    var els = document.querySelectorAll('[data-ship-eta]');
    if (!els.length) return;
    var zip = currentZip();
    Array.prototype.forEach.call(els, function (el) { renderInto(el, zip); });
  }

  function callForEstimate(el) {
    var note = document.createElement('span');
    note.className = 'stock-alert__eta-note';
    note.textContent = unavailableText;
    el.appendChild(note);
    if (!phone) return;
    el.appendChild(document.createTextNode(' '));
    var link = document.createElement('a');
    link.className = 'stock-alert__eta-phone';
    link.href = phoneHref;
    link.textContent = phone;
    link.addEventListener('click', stop); /* don't toggle the alert tooltip */
    link.addEventListener('keydown', stop);
    el.appendChild(link);
  }

  function renderInto(el, zip) {
    el.innerHTML = '';
    el.hidden = false;

    /* Heavy variant: pallet/freight, no ZIP-based estimate. */
    if (currentGrams >= heavyGrams) {
      callForEstimate(el);
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'stock-alert__zip';
    btn.setAttribute('data-ship-zip', '');
    btn.textContent = zip || 'Enter ZIP';
    btn.setAttribute('aria-label', zip ? 'Change delivery ZIP code, currently ' + zip : 'Enter delivery ZIP code');
    /* Keep clicks and Enter/Space away from the parent alert, which toggles its tooltip on both. */
    btn.addEventListener('click', function (e) { e.stopPropagation(); openEditor(el, zip); });
    btn.addEventListener('keydown', stop);

    var st = zip ? stateFor(zip) : null;
    var zone = st && zones[st];

    el.appendChild(document.createTextNode('Estimated delivery to '));
    el.appendChild(btn);
    if (zone) {
      var ship = shipDate();
      var range = formatRange(addBusinessDays(ship, zone[0] + bufferDays), addBusinessDays(ship, zone[1] + bufferDays));
      el.appendChild(document.createTextNode('\u2002' + range));
    } else if (zip) {
      el.appendChild(document.createTextNode('\u2002'));
      callForEstimate(el);
    }
  }

  function openEditor(el, prevZip) {
    el.innerHTML = '';

    var form = document.createElement('div');
    form.className = 'stock-alert__zip-form';
    form.setAttribute('role', 'group');
    form.setAttribute('aria-label', 'Delivery ZIP code');
    /* Nothing inside the editor may bubble to the alert, which toggles its tooltip on click/Enter/Space. */
    form.addEventListener('click', stop);
    form.addEventListener('keydown', stop);

    var inputId = 'shipZipInput-' + Math.random().toString(36).slice(2, 8);
    var label = document.createElement('label');
    label.className = 'stock-alert__zip-label';
    label.htmlFor = inputId;
    label.textContent = 'Enter your delivery ZIP code for an estimate';

    var row = document.createElement('div');
    row.className = 'stock-alert__zip-row';

    var input = document.createElement('input');
    input.type = 'text';
    input.id = inputId;
    input.className = 'stock-alert__zip-input';
    input.inputMode = 'numeric';
    input.maxLength = 5;
    input.pattern = '[0-9]*';
    input.autocomplete = 'postal-code';
    input.placeholder = '00000';
    input.value = prevZip;

    var apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'stock-alert__zip-apply';
    apply.textContent = 'Update';

    var cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'stock-alert__zip-cancel';
    cancelBtn.textContent = 'Cancel';

    var error = document.createElement('span');
    error.className = 'stock-alert__zip-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.textContent = 'Please enter a 5-digit ZIP code';

    var done = false;
    function close() {
      if (done) return;
      done = true;
      document.removeEventListener('click', outside, true);
      render();
    }
    function commit() {
      if (done) return;
      var v = cleanZip(input.value);
      if (!v) {
        error.hidden = false;
        input.classList.add('is-invalid');
        input.focus();
        return;
      }
      saveZip(v);
      close();
    }
    function outside(e) {
      if (!form.contains(e.target)) close();
    }

    input.addEventListener('input', function () {
      error.hidden = true;
      input.classList.remove('is-invalid');
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); commit(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); }
    });
    apply.addEventListener('click', commit);
    cancelBtn.addEventListener('click', close);
    /* Tapping anywhere else closes the editor without saving. Registered after this
     * click finishes so the opening click itself does not close it. */
    setTimeout(function () {
      if (!done) document.addEventListener('click', outside, true);
    }, 0);

    row.appendChild(input);
    row.appendChild(apply);
    row.appendChild(cancelBtn);
    form.appendChild(label);
    form.appendChild(row);
    form.appendChild(error);
    el.appendChild(form);
    input.focus();
    input.select();
  }

  render();

  /* The alert script in product-buy-box.liquid swaps its innerHTML on variant
   * change; its listener was registered first, so by the time this runs the
   * fresh (empty) [data-ship-eta] node is in place. */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v) {
      var g = v.weight != null ? v.weight : v.grams;
      if (isFinite(g)) currentGrams = Number(g);
    }
    render();
  });
})();
